export default function importAllImages() {
const requirement = require.context("../images", false, /\.(png|jpe?g|svg|webp)$/)

  return requirement.keys().reduce((images, path) => {
    const key = path.replace("./", "");
    images[key] = requirement(path);
    return images;
  }, {});
};